
import CommonUtils from "@/common-utils";
import { UgcVO, SlvUgcImgVO, SlvUgcCategoryVO, RelUgcProductVO } from "@/views/biz/ugc/vo/ugc.vo";
import axios from "axios";
import imageCompression from "browser-image-compression";
import  debounce from "lodash-es/debounce";
import VideoSnapshot from "video-snapshot";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import Constants from "../../../constants";
import FeedProductSearchPop from "../feed/FeedProductSearchPop.vue";
import CommonModalDialog from "@/components/CommonModalDialog.vue";
import BottomSheets from "@/components/BottomSheets.vue";

@Component({ components: { FeedProductSearchPop, CommonModalDialog, BottomSheets } })
export default class TalkForm extends Vue {
  maxUploadCount = 10;
  maxImageSizeMB = 0.3;
  maxVideoSizeMB = 50;
  ugcTypeCd = "047011"; // 톡톡

  //data
  @Prop()
  ugcCd?: number;
  ugc: UgcVO = {} as UgcVO;
  ugcProducts: Array<RelUgcProductVO> = [];
  ugcCategories: Array<SlvUgcCategoryVO> = [];

  // 자동 저장 복구 안내 팝업
  showSavedDocumentPop = false;

  // 상품 선택 팝업
  showProductPop = false;

  // 리뷰 이미지 swiper
  swipers = {
    slidesPerView: "3.5",
    spaceBetween: 7,
    freeMode: true,
  };

  autoSaveObj = debounce(this.autoSave, 300);

  //computed

  // 현재 선택된 ugcCategory
  get currentUgcCategory(): SlvUgcCategoryVO {
    let result = {} as SlvUgcCategoryVO;
    if (!this.ugc || !this.ugc.ugcCategoryCd) {
      return result;
    }

    this.ugcCategories.forEach((fc) => {
      if (fc.ugcCategoryCd == this.ugc.ugcCategoryCd) {
        result = fc;
        return;
      }
    });
    return result;
  }

  // 골라주세요임?
  get isBoardTypePick() {
    return this.currentUgcCategory.boardTypeCd == "055003";
  }

  // 일반게시판임?
  get isBoardTypeNormal() {
    return this.currentUgcCategory.boardTypeCd == "055004";
  }

  // QNA게시판임?
  get isBoardTypeQna() {
    return this.currentUgcCategory.boardTypeCd == "055005";
  }

  get feedFiles() {
    this.ugc.files.forEach((v, i) => {
      this.ugc.files[i].sortNo = i;
    });
    return this.ugc.files;
  }

  // 파일 추가
  onBtnAddFile() {
    if (this.ugc.files && this.ugc.files.length >= this.maxUploadCount) {
      // 최대 10개까지 등록 가능합니다
      alert(this.$t("review.a0011").toString());
      return;
    }
    (this.$refs.imgFile as HTMLInputElement).click();
  }

  /**
   * 이미지 사이즈 조정
   */
  async getResizedImage(imageFile: File): Promise<File> {
    const options = {
      maxSizeMB: this.maxImageSizeMB,
      maxWidthOrHeight: 1024,
      useWebWorker: true,
    };
    const compressedFile: Blob = (await imageCompression(imageFile, options)) as Blob;
    return new File([compressedFile], imageFile.name, { type: imageFile.type });
  }

  /**
   * 동영상 사이즈 조정
   */
  async getResizedVideo(videoFile: File): Promise<File> {
    // TODO 리사이즈
    return videoFile;
  }

  /**
   * 동영상 스냅샷
   */
  async getSnapShot(videoFile: File): Promise<File> {
    const snapshoter = new VideoSnapshot(videoFile);
    const test = await snapshoter.takeSnapshot();
    return fetch(test)
      .then((r) => r.blob())
      .then((blob) => {
        return new File([blob], "snapshot.png");
      });
  }

  // 이미지 사진 업로드 후 저장된 값 리턴
  async uploadFile(e) {
    const fileList = e.target.files as FileList;

    if (this.ugc.files && fileList.length + this.ugc.files.length > this.maxUploadCount) {
      // 최대 10개까지 등록 가능합니다
      alert(this.$t("review.a0011").toString());
      return;
    }

    for (let i = 0; i < fileList.length; i++) {
      const file = fileList.item(i);
      if (file == null) {
        continue;
      }

      const filenm = file.name;
      const ext = filenm.split(".")[1].toLowerCase();
      const types = file.type; // video/quicktime, image/png
      const type = types.split("/")[0];
      const size = file.size / 1000000; // conver Byte to MB

      let uploadFile!: File;
      let uploadFile2!: File;
      let uploadUrl!: string;

      switch (type) {
        case "image": // 이미지
          uploadUrl = "/ugc/image";

          if (ext.startsWith("jp") == false && ext != "png") {
            // 이미지는 JPG, PNG파일만 가능합니다.
            this.$toast(this.$t("review.a0021").toString());
            return;
          }

          uploadFile = await this.getResizedImage(file);
          break;
        case "video": // 동영상
          if (size > this.maxVideoSizeMB) {
            // 동영상은 50MB까지 가능합니다
            this.$toast(this.$t("review.a0013").toString());
            return;
          }
          if (ext === "avi" || ext === "mkv") {
            //동영상은 mp4, mov 형식만 지원 가능합니다
            this.$toast(this.$t("review.a0014").toString());
            return;
          }
          uploadUrl = "/ugc/video";

          uploadFile = await this.getSnapShot(file);
          uploadFile2 = await this.getResizedVideo(file);
          break;
        default:
          // 파일의 확장자를 확인해주세요.
          this.$toast(this.$t("review.a0022").toString());
          return;
      }

      // review img는 파일 타입을 저장해야 해서 하나씩 post함
      const formData = new FormData();
      formData.append("bizType", "ugc");
      // 이미지 파일, 비디오 스냅샷
      formData.append("file1", uploadFile, uploadFile.name);
      // 비디오파일
      if (uploadFile2) {
        formData.append("file2", uploadFile2, uploadFile2.name);
      }
      // 업로드해서 fileCd를 취득한다. (굳이 await로 안해도 될듯?)
      axios.post(uploadUrl, formData, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => {
        const uploadedFile = r.data as SlvUgcImgVO;
        !this.ugc.files && (this.ugc.files = []);
        this.ugc.files.push(uploadedFile);
        this.autoSave();
      });
    }
  }

  //피드 수정하기
  getFeed() {
    axios.get(`/ugc/${this.ugcCd}`).then((r) => {
      this.ugc = r.data as UgcVO;
    });
  }

  // 자동 저장(작성하던 리뷰)
  autoSave() {
    // 수정이면
    if (this.ugcCd) {
      return;
    }
    CommonUtils.putLocalStorageObject(Constants.AUTO_SAVED_FEED, this.ugc);
  }

  // 등록
  save(): void {
    if (!this.ugc.ugcCategoryCd) {
      // "a0003": "카테고리를 선택해주세요.",
      return alert(this.$t("ugc.a0003").toString());
    }
    if (this.isBoardTypeQna && !this.ugc.text) {
      // QNA만
      // "a0009": "내용은 필수입니다",
      return alert(this.$t("review.a0009").toString());
    }
    // 골라주세요만
    if (this.isBoardTypePick) {
      if (this.ugc.products.length < 1) {
        // "a0024": "사용하신 제품을 선택해주세요.",
        return alert(this.$t("review.a0024").toString());
      }
      if (this.ugc.products.length < 2 || this.ugc.products.length > 4) {
        // 제품은 2-4개까지 선택 가능합니다.
        return alert(this.$t("ugc.a0011").toString());
      }
    } else {
      // 골라주세요 아니면 상품 ㄴㄴ
      this.ugc.products = [];
    }

    // 등록하시겠습니까?
    if (confirm(this.$t("common.c0001").toString())) {
      // 게시판 유형
      this.ugc.boardTypeCd = this.currentUgcCategory.boardTypeCd;
      axios.post(`/ugc`, this.ugc).then((r) => {
        CommonUtils.removeLocalStorageObject(Constants.AUTO_SAVED_FEED);
        this.$store.commit("touchKeepAlive");
        this.$router.push({ name: "Talks" });
      });
    }
  }
  // 이전에 작성하던 데이터 불러오기
  reloadSavedFeed(feedCheck: boolean) {
    if (feedCheck) {
      const savedFeed = CommonUtils.getLocalStorageObject(Constants.AUTO_SAVED_FEED) as UgcVO;
      if (savedFeed) {
        this.ugc = savedFeed;
        this.showProductPop = false;
      }
    } else {
      CommonUtils.removeLocalStorageObject(Constants.AUTO_SAVED_FEED);
    }
    this.showSavedDocumentPop = false;
  }

  // 대상 상품 추가
  @Watch("showProductPop")
  addProducts() {
    if (this.showProductPop) {
      return;
    }
    this.$set(this.ugc, "products", this.ugcProducts);
    this.autoSave();
  }

  // Bottom Sheet ugc category 선택
  onBsCategorySelected(ugcCategoryCd: number) {
    this.$set(this.ugc, "ugcCategoryCd", ugcCategoryCd);
    BottomSheets.closeAll(); // 얘는 can close 무시함
  }

  created(): void {
    const params = {
      ugcType: "03",
      pointTypeCd: "019055"
    };
    axios
      .get(`/ugc/categories`, { params: params })
      .then((r) => {
        this.ugcCategories = r.data;
      })
      .catch(() => {
        this.$router.go(-1);
      });
    this.$set(this.ugc, "files", []);
    this.$set(this.ugc, "products", []);
    this.$set(this.ugc, "ugcTypeCd", this.ugcTypeCd);
    if (this.ugcCd) {
      // 수정
      this.showProductPop = false;
      this.getFeed();
    } else {
      // 이전에 작성하던 데이터 불러올지 여부
      if (CommonUtils.getLocalStorageObject(Constants.AUTO_SAVED_TALK) as UgcVO) {
        this.showSavedDocumentPop = true;
      }
    }
  }

  mounted() {
    // 카테고리 선택
    (this.$refs.ugcCategoryBs as BottomSheets).open();
  }
}
